<template>
  <div class="bg-gray-100 border-b-[2px] border-postRed py-4">
    <div class="w-content-standard flex justify-between items-center mx-auto min-h-[60px]">
      <!-- Back Button -->
      <button
          v-if="show_back"
          @click="go_back"
          class="back-button bg-white text-postRed font-bold text-[1.25rem] w-[60px] h-[60px] border-[2px] border-postRed rounded-[4px]"
      >
        ←
      </button>
      <div v-else class="w-[60px] h-[60px]"></div>

      <div class="flex items-center flex-end flex-1 pl-4">
        <img :src="`/images/post-logo.png`" class="max-h-[40px] mr-2">
        <div class="font-serif text-postRed text-3xl">Upload App</div>
      </div>
    </div>
    
    <!-- Burger Menu -->
    <Menu right>
      <nav>
        <div class="menu-item">
          <a class="block" href="#" @click="logout">Log Out</a>
          <a class="block" href="#" @click="clear_cache">Clear Cache</a>
          <a class="block" href="#" @click="refreshPermissions">Refresh Permissions</a>
        </div>
      </nav>
    </Menu>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router';
import { Menu } from 'vue3-burger-menu';
import axios from 'axios';
import { useAppStore } from '@/store/app';

// Define props
const props = defineProps({
  show_back: {
    type: Boolean,
    default: false
  }
});

// Use Vue Router for navigation
const router = useRouter();
const appStore = useAppStore();

// Function to go back
const go_back = () => {
  router.back();
};

const refreshPermissions = async () => {
  try {
    const result = await appStore.refreshLocationPermissions();
    if (result.success) {
      if (result.refreshed) {
        alert('Permissions refreshed successfully from WordPress');
      } else {
        alert('Permissions loaded, but WordPress did not return updated permissions. Permissions can only be refreshed on login. Please log out and log back in to get the latest permissions.');
      }
    } else {
      alert('Failed to refresh permissions. Please try again.');
    }
  } catch (error) {
    console.error('Error refreshing permissions:', error);
    alert('Error refreshing permissions. Please try again.');
  }
};

const logout = async () => {
  try {
    await axios.post('/api/logout'); // Adjust this route to match your Laravel backend
    window.location.href = '/#/login'; // Redirect to login page after logout
  } catch (error) {
    console.error('Error logging out:', error);
  }
};

const clear_cache = async () => {
  try {
    await axios.get('/clear-cache'); // Adjust this route to match your Laravel backend
    alert('Cache cleared');
  } catch (error) {
    console.error('Error clearing cache:', error);
  }
};
</script>

<style>
.back-button {
  cursor: pointer;
}

/* Add some basic styling for menu items */
.menu-item {
  padding: 1rem;
  color: white;
}

.bm-menu {
  background-color: #686868
}

.bm-burger-button {
  top: 31px !important;
  left: unset !important;
  right: 8.33% !important;
}

.bm-burger-button .bm-burger-bars {
  background: rgb(174 24 16) !important;
}

.cross-style {
    top: 20px !important;
    right: 12px !important;
}

.bm-cross {
  height: 25px !important;
}
</style>